import { isValidPhoneNumber } from 'libphonenumber-js'
export default {
    computed: {
        rules() {
            let email_regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            
            return {
                required: v => !!v || this.$t('Обязательное поле.'),
                nameRule: min => {
                    return v => {
                        if (!v || v.length <= min || v === this.$t('Не задано')) {
                            return `${this.$t('Требуется значение с количеством символов больше')} ${min}`;
                        }
                        if (/\d/.test(v)) {
                            return this.$t('Имя не должно содержать цифры');
                        }
                        return true;
                    }
                },
                emailRule: v => (!v || email_regex.test(v) || v == this.$t('Не задано')) || this.$t('E-mail не валиден'),
                phoneRule: v => isValidPhoneNumber(v) ? true : this.$t('Ожидается номер телефона в международном формате'),
                addressAccuracyRule: v => (v || v.accuracy > 7) && this.$t('Неточный адрес'),
                noNegativeNumber: v => (v && !(v < 0)) || this.$t('Значение не может быть отрицательным')
            }
        }
    }
}